import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "~/app/api/pageData/pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { PasswordChangePageInitialData } from "./passwordChangePageInitialData";

export interface PasswordChangePageQueryInput {
  token: string | null;
  newCustomer: boolean;
}

/**
 * Build the OCC `/page-data/login/pw/change` URL carrying the original
 * `token` / `newCustomer` query params from the page URL. The token flows back through
 * the OCC page-data endpoint so the facade can re-validate it and return OK / REDIRECT (blank
 * token) / OK with no data (expired token) consistently.
 */
function buildPageDataUrl(token: string | null, newCustomer: boolean): string {
  const params = new URLSearchParams();
  if (token) {
    params.set("token", token);
  }
  params.set("newCustomer", String(newCustomer));
  const query = params.toString();
  return `/page-data/login/pw/change${query ? `?${query}` : ""}`;
}

export const passwordChangePageQueryOptions = ({ token, newCustomer }: PasswordChangePageQueryInput) =>
  queryOptions({
    queryKey: pageDataKeys.pageWithInputs("login/pw/change", { token: token || null, newCustomer }),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<PasswordChangePageInitialData | void>>(
        buildPageDataUrl(token, newCustomer),
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
